import type { api } from "~/utils/api"

type ApiUtils = ReturnType<typeof api.useUtils>

/**
 * Fire-and-forget invalidation of the adjustment list queries — cheap, used
 * from onError paths. Success paths go through useRefreshForecastDomain,
 * whose router-wide adjustment invalidate covers these.
 */
export function invalidateAdjustmentQueries(utils: ApiUtils) {
  utils.adjustment.get.invalidate()
  utils.adjustment.getTopAdjustments.invalidate()
  utils.adjustment.getAdjustmentUnitImpact.invalidate()
}
